import { useQuery } from '@tanstack/react-query';
import { businessKeys } from '@platform/billing';
import { STALE_TIME } from '@/shared/constants/app/time.constant';
import { businessApi } from './business.api';
import type { OrgMember } from '../types/business.type';

/**
 * web 에 남는 조직 조회는 **콘솔 진입 판정과 초대 수락** 뿐이다.
 * 구성원·시트·결제 조회는 console-web 으로 이관됐다 — 여기 다시 추가하지 말 것.
 */

/**
 * 현재 사용자가 속한 조직 멤버십 목록. 콘솔 진입 링크 노출(useOrgAccess)의 소스.
 * 헤더 등 로그인 전역에서 호출되므로 staleTime 을 두어 페이지 이동마다 재요청하지 않게 한다.
 */
export function useMyGroups() {
  return useQuery({
    queryKey: businessKeys.myGroups,
    queryFn: businessApi.myGroups,
    staleTime: STALE_TIME.MEDIUM,
  });
}

/**
 * 내 소속(단일). 서버가 계정당 ACTIVE 멤버십 1건을 보장하므로 배열을 여기서 흡수한다.
 * `useMyGroups` 와 queryKey 가 같아 캐시를 공유한다 — 요청이 두 번 나가지 않는다.
 */
export function useMyOrg() {
  return useQuery({
    queryKey: businessKeys.myGroups,
    queryFn: businessApi.myGroups,
    select: (rows: OrgMember[]) => rows[0] ?? null,
    staleTime: STALE_TIME.MEDIUM,
  });
}

